<script setup lang="ts">
import { changePassword } from '@yc/api-client'
import { ref, watch } from 'vue'

const oldPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const submitting = ref(false)
const error = ref('')
const done = ref(false)

watch([newPassword, confirmPassword], () => {
  error.value = ''
})

async function submit(): Promise<void> {
  if (newPassword.value !== confirmPassword.value) {
    error.value = '两次输入的新密码不一致'
    return
  }
  submitting.value = true
  error.value = ''
  try {
    await changePassword({ old_password: oldPassword.value, new_password: newPassword.value })
    done.value = true
  } catch (e) {
    error.value = e instanceof Error ? e.message : '修改失败'
  } finally {
    submitting.value = false
  }
}
</script>

<template>
  <form class="yc-change-pwd" @submit.prevent="submit">
    <el-form-item label="原密码">
      <el-input v-model="oldPassword" type="password" show-password placeholder="请输入原密码" />
    </el-form-item>
    <el-form-item label="新密码">
      <el-input v-model="newPassword" type="password" show-password placeholder="8~64 位，含字母和数字" />
    </el-form-item>
    <el-form-item label="确认新密码">
      <el-input v-model="confirmPassword" type="password" show-password placeholder="再次输入新密码" />
    </el-form-item>

    <el-alert v-if="error" type="error" :closable="false" show-icon :title="error" />

    <el-button type="primary" :loading="submitting" native-type="submit">
      确认修改
    </el-button>
  </form>
</template>

<style scoped lang="scss">
.yc-change-pwd {
  display: flex;
  flex-direction: column;
  gap: var(--yc-space-4);
}
</style>
